import React from "react"
import {
    componentStyles,
    ConditionalRenderContainer,
    VerticalStackStretch,
} from "@mallardbay/lib-react-components"

import TripMap from "~components/shared/trip-map/trip-map"
import Box from "~components/shared/todo-lib-react-components/box"
import AspectRatio from "~components/shared/todo-lib-react-components/aspect-ratio"
import CopiableInput from "~components/shared/copiable-input"
import { getFullLocation } from "~utils/helpers"
import GetDirectionsButton from "~components/pages/booking/get-directions-button"
import type {
    AddressFieldsFragment,
    ListingType,
} from "~graphql/generated/graphql"

interface Props {
    readonly location?: AddressFieldsFragment | null
    readonly shouldShowMap?: boolean
    readonly listingType?: ListingType | null
}

export default function Location({
    location,
    shouldShowMap,
    listingType,
}: Props) {
    const styles = useStyles()

    const fullLocation = getFullLocation(location)

    if (!fullLocation) return null

    return (
        <VerticalStackStretch>
            <ConditionalRenderContainer shouldRender={shouldShowMap}>
                <AspectRatio ratio={21 / 9}>
                    <Box style={styles.mapContainer}>
                        <TripMap location={location} type={listingType} />
                    </Box>
                </AspectRatio>
            </ConditionalRenderContainer>
            <CopiableInput value={fullLocation} />
            <GetDirectionsButton address={fullLocation} />
        </VerticalStackStretch>
    )
}

function useStyles() {
    return componentStyles({
        mapContainer: {
            borderRadius: "16px",
            overflow: "hidden",
        },
    })
}
